
namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    export class JobWorkItemsGrid extends Serenity.EntityGrid<JobWorkItemsRow, any> {
        protected getColumnsKey() { return 'JobWork.JobWorkItems'; }
        protected getDialogType() { return JobWorkItemsDialog; }
        protected getIdProperty() { return JobWorkItemsRow.idProperty; }
        protected getInsertPermission() { return JobWorkItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkItemsRow.localTextPrefix; }
        protected getService() { return JobWorkItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}